"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemEntityData = void 0;
const typebox_1 = require("@sinclair/typebox");
const service_location_1 = require("./service-location");
exports.LineItemEntityData = typebox_1.Type.Partial(typebox_1.Type.Object({
    refStatus: typebox_1.Type.String(),
    refNumber: typebox_1.Type.String(),
    refServiceLocation: service_location_1.ServiceLocationTransport,
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.String({ format: 'date' }),
}));
//# sourceMappingURL=line-item-entity-data.js.map